<template>
  <v-card flat class="white vetalfa-view vetalfa-max-width">
    <vetalfa-email-component v-if="emailConfirmation"></vetalfa-email-component>
    <vetalfa-topics></vetalfa-topics>
    <vetalfa-drugs-interactions
      :triggerModel="drugsInteractionsModel"
    ></vetalfa-drugs-interactions>
    <div ref="screenHeader" class="vetalfa-header">
      <v-card
        flat
        elevation="3"
        class="small-header-top-bar small-header-top-bar-notch"
        :max-width="_getMaxWidth()"
      >
        <v-row class="ma-0 pa-0 small-header-top-bar-row">
          <v-col class="ma-0 pa-0" cols="6">
            <v-row align="center" class="ma-0 pa-0 vetalfa-row">
              <v-img
                height="44px"
                position="left"
                class="ma-0 pa-0 ml-2"
                contain
                :src="logo"
                :lazy-src="logo"
              ></v-img>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0" cols="6">
            <v-row align="center" justify="end" class="ma-0 pa-0 vetalfa-row">
              <v-icon
                @click="openGlobalSearches()"
                class="vetalfa-pointer ma-0 pa-0 mr-5"
                color="white"
              >
                {{ mdiMagnify }}
              </v-icon>
              <!-- <v-icon
                @click="openRecentlySeen()"
                class="vetalfa-pointer ma-0 pa-0 mr-5"
                color="white"
              >
                {{ mdiProgressClock }}
              </v-icon> -->
              <!-- <v-img
                @click="setUserSection(true)"
                class="vetalfa-pointer ma-0 pa-0 mr-4"
                max-width="20px"
                height="20px"
                position="center"
                :src="gear"
                :lazy-src="gear"
              ></v-img> -->
            </v-row>
          </v-col>
        </v-row>
        <vetalfa-user-section></vetalfa-user-section>
      </v-card>
    </div>
    <div ref="screenContent">
      <v-row class="ma-0 pa-0 pa-1">
        <!-- <v-col class="ma-0 pa-0 px-2" cols="12">
          <p class="ma-0 pa-0 items-row-letter primary--text">
            {{ _getLabel("HIGHLIGHTS") }}
          </p>
        </v-col>
        <v-col
          v-for="(section, index) in sectionsEnum.sections.filter((s) => {
            return !!s.new;
          })"
          :key="`${section.name}-home-${index}`"
          :cols="$vuetify.breakpoint.xs ? 6 : 4"
          class="ma-0 px-2 py-2"
        >
          <v-card
            @click="
              !section.method
                ? sectionsEnum.goToSection({
                    section,
                    dispatch: $store.dispatch,
                  })
                : openMethod(section.method)
            "
            height="100px"
            class="ma-0 pa-2 vetalfa-card-border-item"
            outlined
          >
            <v-row aling="center" class="ma-0 pa-0 vetalfa-row">
              <v-col class="ma-0 pa-0" cols="2">
                <v-img
                  contain
                  :src="section.image"
                  height="30"
                  max-width="30"
                ></v-img>
              </v-col>
              <v-col class="ma-0 pa-0" cols="10">
                <v-row align="center" class="vetalfa-row ma-0 pa-0 pl-2">
                  <p class="items-title ma-0 pa-0">
                    {{ section.name }}
                  </p>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col> -->
        <v-col v-if="!!trends" class="ma-0 pa-0 px-2" cols="12">
          <p class="ma-0 pa-0 items-row-letter primary--text">
            {{ _getLabel("TRENDS") }}
          </p>
        </v-col>
        <v-col v-if="!!trends" class="ma-0 pa-0 ml-2" cols="12">
          <v-slide-group
            class="mb-2"
            :show-arrows="!$vuetify.breakpoint.xsOnly && !_isCordovaApp()"
          >
            <v-slide-item v-for="item in trends" :key="item.name">
              <v-card
                @click="openTrends({ ...item })"
                height="53px"
                width="200px"
                class="vetalfa-pointer ma-0 my-1 pa-2 mr-2 vetalfa-card-border-item"
                outlined
              >
                <v-row class="ma-0 pa-0 vetalfa-row" align="center">
                  <v-col class="ma-0 pa-0" cols="12">
                    <v-row aling="center" class="ma-0 pa-0">
                      <p
                        v-html="item.name"
                        v-bind:class="
                          (!!item.description &&
                          item.description !==
                            _getLabel('ACTIVE_PRINCIPLE_SINGULAR')
                            ? 'items-products-title'
                            : 'items-title') + ' ma-0 items-two-lines-clamp'
                        "
                      ></p>
                    </v-row>
                    <v-row aling="center" class="ma-0 pa-0">
                      <p class="ma-0 pa-0 mt-1 items-description-label">
                        {{ item.category }}
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
        <v-col class="ma-0 pa-0 px-2" cols="12">
          <p class="ma-0 pa-0 items-row-letter primary--text">
            {{ _getLabel("CATEGORIES") }}
          </p>
        </v-col>
        <v-col
          v-for="(section, index) in sectionsEnum.sections.filter((s) => {
            return !s.new;
          })"
          :key="`${section.name}-home-${index}`"
          :cols="$vuetify.breakpoint.xs ? 6 : 4"
          class="ma-0 px-2 py-2"
        >
          <v-card
            @click="
              !section.method
                ? sectionsEnum.goToSection({
                    section,
                    dispatch: $store.dispatch,
                  })
                : openMethod(section.method)
            "
            height="100px"
            class="ma-0 pa-2 vetalfa-card-border-item"
            outlined
          >
            <v-row aling="center" class="ma-0 pa-0 vetalfa-row">
              <v-col class="ma-0 pa-0" cols="2">
                <v-img
                  contain
                  :src="section.image"
                  height="30"
                  max-width="30"
                ></v-img>
              </v-col>
              <v-col class="ma-0 pa-0" cols="10">
                <v-row align="center" class="vetalfa-row ma-0 pa-0 pl-2">
                  <p class="items-title ma-0 pa-0">
                    {{ section.name }}
                  </p>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style>
.home-section-title {
  width: 100%;
  font-size: 14px;
  color: #004662;
  letter-spacing: 0;
}
</style>

<script>
import {
  mdiProgressClock,
  mdiMagnify,
  mdiBell,
  mdiStarFourPoints,
  mdiChevronRight,
  mdiChevronLeft,
} from "@mdi/js";
import { mapMutations, mapActions, mapGetters } from "vuex";
import images from "@/constants/images.js";
import sectionsEnum from "@/constants/sections.enum.js";
import UserSection from "@/components/UserSection.vue";
import Email from "@/components/Email.vue";
import Topics from "@/components/Topics.vue";
import DrugsInteractions from "@/components/complete/DrugsInteractions.vue";
export default {
  name: "Home",
  components: {
    "vetalfa-user-section": UserSection,
    "vetalfa-email-component": Email,
    "vetalfa-topics": Topics,
    "vetalfa-drugs-interactions": DrugsInteractions,
  },
  methods: {
    ...mapMutations("general", [
      "setUserSection",
      "setDisclaimer",
      "setConfirmModel",
    ]),
    ...mapActions("general", [
      "initializeApp",
      "routePathRedirect",
      "logEvent",
    ]),
    ...mapActions("drugs", ["clearNavigationHistory"]),
    ...mapActions("preferences", ["openRecentlySeen", "openGlobalSearches"]),
    ...mapActions("purchases", ["openPurchases"]),
    openMethod(method) {
      return {
        openInteractions: function () {
          if (!this.disclaimer) {
            this.setDisclaimer(true);
            this.setConfirmModel({
              active: true,
              alert: true,
              callback: function () {
                this.drugsInteractionsModel = this._getTimestamp();
              }.bind(this),
              text: this._getLabel("DISCLAIMER"),
              confirmText: this._getLabel("CONTINUE"),
            });
          } else {
            this.drugsInteractionsModel = this._getTimestamp();
          }
        }.bind(this),
      }[method]();
    },
    openTrends(item) {
      this.logEvent("openTrends");
      this.routePathRedirect(item);
    },
  },
  computed: {
    ...mapGetters("general", [
      "homeAdds",
      "emailConfirmation",
      "trends",
      "user",
      "isPremium",
      "disclaimer",
    ]),
  },
  data() {
    return {
      logo: images.LOGO_SMALL_HEADER,
      gear: images.GEAR,
      sectionsEnum,
      mdiMagnify,
      mdiProgressClock,
      mdiBell,
      mdiStarFourPoints,
      mdiChevronRight,
      mdiChevronLeft,
      drugsInteractionsModel: null,
    };
  },
  mounted() {
    this._setupScreenSizes(this);
    this.$nextTick(() => {
      if (!!this.$route.query.interactions) {
        this.openMethod("openInteractions");
      }
    });
  },
  created: async function () {
    await this.initializeApp();
    this.clearNavigationHistory();
    if (this.$route.query.category) {
      await this.sectionsEnum.goToSection({
        id: this.$route.query.category,
        dispatch: this.$store.dispatch,
      });
    }
  },
};
</script>